import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import React from 'react';
import LanguageAvatar from './LanguageAvatar';

class LanguageAdornment extends React.Component {

    render() {

        const { lang } = this.props;

        return (
            <InputAdornment position="start">
                <LanguageAvatar lang={lang}/>
            </InputAdornment>
        );
    }
}

LanguageAdornment.propTypes = {
    lang: PropTypes.string.isRequired
};

export default LanguageAdornment;